import { memo, useEffect, useState } from 'react'
import { Select, MenuItem } from '@material-ui/core'
import { uniqueId } from 'lodash'
import moment from 'moment'
import { useDefaultLanguage } from 'commons/useDefaultLanguage'
import {
  HEADERS_IMPORT_CSV_FILE,
  keysToLowercase,
  dateColumns,
} from '../../constansts'
import { formattedDate } from '../../ImportFromCsv/StepOne/helpers'
import AutocompleteJobTitle from './AutocompleteJobTitle'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import EventIcon from '@material-ui/icons/Event'

import useStyles from './styles'

const headersFilteredByOptions = HEADERS_IMPORT_CSV_FILE.filter(
  ({ options }) => options,
)

const EditableCell = ({
  index,
  id,
  initialValue,
  row,
  updateData,
  changedHeaderkey,
  optionsLanguages,
}) => {
  const classes = useStyles()
  const [value, setValue] = useState(initialValue)
  const [isCalenderOpen, setIsCalenderOpen] = useState(false)

  const defaultLanguage = useDefaultLanguage()

  const headerKey = changedHeaderkey || id

  const isDateColumn = dateColumns.includes(headerKey)

  let inputType = isDateColumn ? 'date' : 'text'

  const onChange = (value) => {
    if (isDateColumn) {
      setValue(value !== '' ? formattedDate(value, 'M/D/YYYY') : null)
    } else {
      setValue(value)
    }
  }

  useEffect(() => {
    if (initialValue !== value) {
      setValue(initialValue)
    }
  }, [initialValue])

  useEffect(() => {
    const request = {}
    if (initialValue !== value) {
      const changedSubscriber = { ...row, [id]: value }
      updateData?.({ changedSubscriber, index, request })
    }

    return () => {
      if (request.sendToValidateRequest) {
        request.sendToValidateRequest.abort()
      }
    }
  }, [value])

  const getLanguageOptions = () => {
    if (headerKey === 'preferred_language') {
      return optionsLanguages.length
        ? optionsLanguages
        : [{ name: defaultLanguage.name, code: defaultLanguage.code }]
    } else {
      const headerItem =
        headersFilteredByOptions.find(({ header }) => headerKey === header) ||
        {}
      return headerItem.options
    }
  }

  const options = getLanguageOptions()

  let currentValueInput = value

  if (inputType === 'date') {
    const formattedDateValue = formattedDate(value, 'YYYY-MM-DD')

    if (value !== null && !moment(value).isValid()) {
      inputType = 'text'
    } else {
      currentValueInput = formattedDateValue
    }
  }

  if (keysToLowercase.includes(headerKey)) {
    currentValueInput = currentValueInput.toLowerCase()
  }

  const renderMenuItems = (options) => {
    return options.map((option) => {
      const value = option?.name || option
      return (
        <MenuItem
          key={uniqueId()}
          value={
            keysToLowercase.includes(headerKey) ? value?.toLowerCase() : value
          }
        >
          {value}
        </MenuItem>
      )
    })
  }

  return options ? (
    headerKey === 'job_role' ? (
      <AutocompleteJobTitle
        currentValueInput={currentValueInput}
        onChange={onChange}
      />
    ) : (
      <Select
        value={currentValueInput}
        fullWidth
        className={classes.root}
        IconComponent={() => null}
        onChange={(e) => {
          onChange(e.target.value)
        }}
        MenuProps={{
          classes: { paper: classes.select },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        {renderMenuItems(options)}
      </Select>
    )
  ) : isDateColumn ? (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        value={currentValueInput}
        onChange={(date) => onChange(date)}
        format="MM/dd/yyyy"
        fullWidth
        open={isCalenderOpen}
        onOpen={() => setIsCalenderOpen(true)}
        onClose={() => setIsCalenderOpen(false)}
        InputProps={{
          disableUnderline: true,
          readOnly: true,
        }}
        onClick={() => setIsCalenderOpen(true)}
        keyboardIcon={<EventIcon className={classes.dateIcon} />}
        KeyboardButtonProps={{
          'aria-label': 'change date',
          style: { padding: '2px' },
          id: `${id}-keyboard-date`,
        }}
        invalidDateMessage=""
        minDateMessage=""
      />
    </MuiPickersUtilsProvider>
  ) : (
    <input
      value={currentValueInput}
      type={inputType}
      className={classes.cellInput}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}

export default memo(EditableCell)
